module.exports = __webpack_public_path__ + "assets/img/h3_logo_darker_shadow.1c077f45.png";